<template>
  <div
    v-if="bannerVisible"
    :class="`cc-maintenance-banner ${!mobile && store.isAdmin ? 'cc-maintenance-banner-desktop' : ''}`"
  >
    <v-alert
      type="warning"
      variant="tonal"
      density="compact"
      :icon="Icons.WRENCH_OUTLINE"
      class="ma-0 rounded-0"
    >
      <span class="font-weight-medium">{{ t('maintenance.banner.scheduled.prefix') }} {{ formattedRange }}</span>
      <span
        v-if="message"
        class="ml-2"
      >— {{ message }}</span>
    </v-alert>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import moment from 'moment';
import {Icons} from '@simpleforyou/client-core';
import {bannerVisible, startsAt, endsAt, message} from '@/composables/common/maintenance/useMaintenance';
import {useDisplay} from 'vuetify/framework';
import {useStore} from '@/common/store/store';

const store = useStore();
const {mobile} = useDisplay();
const {t} = useI18n();

const formattedRange = computed(() => {
  if (!startsAt.value || !endsAt.value) {
    return '';
  }
  const start = moment(startsAt.value);
  const end = moment(endsAt.value);
  // Same day → "15.06.2026 von 22:00 bis 23:00 Uhr".
  // Different day → "15.06.2026 22:00 bis 16.06.2026 02:00 Uhr".
  if (start.isSame(end, 'day')) {
    return `${start.format('DD.MM.YYYY')} ${t('common.from')} ${start.format('HH:mm')} ${t('common.to')} ${end.format('HH:mm')} Uhr`;
  }
  return `${start.format('DD.MM.YYYY HH:mm')} ${t('common.to')} ${end.format('DD.MM.YYYY HH:mm')} Uhr`;
});
</script>

<style lang="scss" scoped>
.cc-maintenance-banner {
  position: relative;
  z-index: 10;
}

.cc-maintenance-banner-desktop {
  padding-left: 256px;
}

</style>
